var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    _vm.$style.component,
    {
      [_vm.$style.smaller]: _vm.isSmaller,
      [_vm.$style.small]: _vm.isSmall,
      [_vm.$style.medium]: _vm.isMedium,
      [_vm.$style.large]: _vm.isLarge,
    },
  ]},[_c('div',{class:[_vm.$style.ring, _vm.$style.top]}),_c('div',{class:_vm.$style.ring}),_c('div',{class:[_vm.$style.ring, _vm.$style.bottom]})])
}
var staticRenderFns = []

export { render, staticRenderFns }